//todo 引入：import format from '../../utils/format'
//todo 示例： this.startLimit = format( this.startLimit, 'YYYY-MM-DD HH:mm:ss')

export default {

  /**
   * @Description: 时间格式化
   * @author wcd
   * @date 2020/2/19
   */
  dateFormat(date, format='YYYY-MM-DD HH:mm:ss') {
    if (!date) {
      return ''
    }

    let d = new Date(date)

    // 年
    if (/YYYY/.test(format)) {
      format = format.replace(/YYYY/, d.getFullYear())
    }
    // 月份
    let month = d.getMonth() + 1
    if (/MM/.test(format)) {
      let monthStr = month < 10 ? '0' + month : month
      format = format.replace(/MM/, monthStr)
    } else if (/M/.test(format)) {
      format = format.replace(/M/, month)
    }
    // 日期
    let dates = d.getDate()
    if (/DD/.test(format)) {
      let dateStr = dates < 10 ? '0' + dates : dates
      format = format.replace(/DD/, dateStr)
    } else if (/D/.test(format)) {
      format = format.replace(/D/, dates)
    }
    // 小时
    let hours = d.getHours()
    if (/HH/.test(format)) {
      let hoursStr = hours < 10 ? '0' + hours : hours
      format = format.replace(/HH/, hoursStr)
    } else if (/H/.test(format)) {
      format = format.replace(/H/, hours)
    } else if (/hh/.test(format)) {
      let hoursMin = hours > 12 ? hours - 12 : hours
      let hoursStr = hoursMin < 10 ? '0' + hoursMin : hoursMin
      format = format.replace(/hh/, hoursStr)
    } else if (/h/.test(format)) {
      let hoursMin = hours > 12 ? hours - 12 : hours
      format = format.replace(/h/, hoursMin)
    }
    // 分
    let minutes = d.getMinutes()
    if (/mm/.test(format)) {
      let minutesStr = minutes < 10 ? '0' + minutes : minutes
      format = format.replace(/mm/, minutesStr)
    } else if (/m/.test(format)) {
      format = format.replace(/m/, minutes)
    }
    // 秒
    let seconds = d.getSeconds()
    if (/ss/.test(format)) {
      let secondsStr = seconds < 10 ? '0' + seconds : seconds
      format = format.replace(/ss/, secondsStr)
    } else if (/s/.test(format)) {
      format = format.replace(/s/, seconds)
    }
    return format
  },
//todo 时间戳格式化
  timeFormat(time, num) {
    var date = new Date(time)
    var year = date.getFullYear()
    /* 在日期格式中，月份是从0开始的，因此要加0
     * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
     * */
    var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
    var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
    var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
    var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
    var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    // 拼接
    for (let i = 1; i < 6; i++) {
      if (num === 3) {
        return year + '-' + month + '-' + day
      }
      if (num === 6) {
        return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
      }
    }
    return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
  },

  /**
   * @Description: todo 判断字符串是否为Date
   * @author wcd
   * @date 2020/2/21
   */
  strIsDate(stringDate) {
    return isNaN(stringDate) && !isNaN(Date.parse(stringDate))
  },

  /**
   * @Description: todo 计算两个时间相差多少天
   * @author wcd
   * @date 2020/2/21
   */
  DayDifference(now, end) {
    try {
      // var day1 = new Date("2017-9-17");
      // var day2 = new Date("2017-10-18");
      let day1 = new Date(now)
      let day2 = new Date(end)
      return (day2 - day1) / (1000 * 60 * 60 * 24)
    } catch (e) {
      console.error(e)
    }

  },


  /**
   * @Description: todo 判断某个时间是否处在某个时间段内
   * @author wcd
   * @date 2020/2/21
   */
  inTime(beginDateStr, endDateStr, targetDate) {
    let curDate = new Date(targetDate),
      beginDate = new Date(beginDateStr),
      endDate = new Date(endDateStr);
    if (curDate >= beginDate && curDate <= endDate) {
      return true;
    }
    return false;
  }


}






// WEBPACK FOOTER //
// ./src/utils/cdUtils/dateUtils.js